import { BasicsClass } from '@/common/BasicsClass';
import { Util } from '@/common/util';

export default class ShopAlipayQrcodeAuthAPI extends BasicsClass {
  public apiUrls: any = new Map([
    ['getShopAlipayQrcodeList', {
      url: '/admin/shop/allinpay/qrcode',
      name: 'list',
      label: '列表'
    }],
    // ['addShopAlipayQrcode', {
    //   url: '/admin/sellerMachine/add',
    //   name: 'add',
    //   label: '添加'
    // }],
    ['updateShopAlipayQrcode', {
      url: '/admin/shop/allinpay/qrcode/save',
      name: 'edit',
      label: '编辑'
    }],
    // ['deleteShopAlipayQrcode', {
    //   url: '/admin/sellerMachine/delete',
    //   name: 'delete',
    //   label: '删除'
    // }],
    // ['searchVenueList', {
    //   url: '/admin/coupons/shop/list',
    //   name: 'shop-list',
    //   label: '店铺列表',
    //   // hidden: true
    // }],
  ])

  // 阿里支付认证二维码列表
  public getShopAlipayQrcodeList(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
    const apiUrls = this.apiUrls

    const url = apiUrls.get('getShopAlipayQrcodeList').url

    this.BasicPost(url, {
      ...params
    }, false, false, false, successCb, failCb, showLoading)
  }

  // 修改阿里支付认证二维码
  public updateShopAlipayQrcode(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
    const apiUrls = this.apiUrls

    const url = apiUrls.get('updateShopAlipayQrcode').url

    this.BasicPost(url, {
      ...params
    }, false, false, false, successCb, failCb, showLoading)
  }

  // // 添加阿里支付认证二维码
  // public addShopAlipayQrcode(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
  //   const apiUrls = this.apiUrls

  //   const url = apiUrls.get('addShopAlipayQrcode').url

  //   this.BasicPost(url, {
  //     ...params
  //   }, false, false, false, successCb, failCb, showLoading)
  // }

  // 删除阿里支付认证二维码
  // public deleteShopAlipayQrcode(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
  //   const apiUrls = this.apiUrls

  //   const url = apiUrls.get('deleteShopAlipayQrcode').url

  //   this.BasicPost(url, {
  //     ...params
  //   }, false, false, false, successCb, failCb, showLoading)
  // }

  // // 搜索店铺列表
  // public searchVenueList(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
  //   const apiUrls = this.apiUrls

  //   const url = apiUrls.get('searchVenueList').url

  //   this.BasicPost(url, {
  //     ...params
  //   }, false, false, false, successCb, failCb, showLoading)
  // }
}